import lodash from 'lodash';

import {
  CoachingFormData,
  CoachingFormInputData,
} from '../../api/CoachingForm/schema';

const trimCoachingData = (note: CoachingFormData): CoachingFormInputData => {
  let newNote = JSON.parse(JSON.stringify(note));

  if (note.createdAt) newNote = lodash.omit(newNote, ['createdAt']);

  if (note.updatedAt) newNote = lodash.omit(newNote, ['updatedAt']);

  if (note.deliveredAt) newNote = lodash.omit(newNote, ['deliveredAt']);

  newNote = lodash.omit(newNote, ['goals']);

  return newNote;
};

export default trimCoachingData;
